var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ItemChipsWithMore", {
    attrs: {
      items: _vm.managersData,
      navigateTo: _vm.navigateToManagersTab,
      routeName: _vm.RouteNames.MANAGER_ABOUT,
      maxChipWidth: "max-w-full",
      isPerson: "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }